import * as React from "react";
import { styled } from "@mui/material/styles";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { styled as styledComp } from "styled-components";
import { lightThemeColors } from "../../assets/styles/colors";
import { Stack } from "@mui/material";

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 48,
  height: 24,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(24px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor:
          theme.palette.mode === "dark"
            ? lightThemeColors.primaryColor
            : lightThemeColors.primaryColor,
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: lightThemeColors.primaryColor,
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 20,
    height: 20,
  },
  "& .MuiSwitch-track": {
    borderRadius: 12,
    backgroundColor:
      theme.palette.mode === "light"
        ? lightThemeColors.darkColorFullFaded
        : "red",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 200,
    }),
  },
}));

export const CustomSwitchLeft = ({
  text,
  icon,
  selectedOption,
  setSelectedOption,
  style,
}) => {
  const handleSwitchChange = (e) => {
    const { checked } = e.currentTarget;
    setSelectedOption(checked);
  };

  return (
    <StyledStack
      direction="row"
      spacing={"15px"}
      alignItems="center"
      style={style}
    >
      <OptionWrapper selected={selectedOption === true}>
        <p>{text}</p>
        {icon}
      </OptionWrapper>

      <FormControlLabel
        onChange={(e) => handleSwitchChange(e)}
        checked={selectedOption}
        control={<IOSSwitch sx={{ m: 0 }} />}
      />
    </StyledStack>
  );
};

const StyledStack = styled(Stack)``;
const OptionWrapper = styledComp.div`
display:flex;
align-items:center;
gap:10px;
p{
    font-size: 13px;
    font-weight: 500;
    text-align: left;
    color:${(props) =>
      props.selected
        ? lightThemeColors.primaryColor
        : lightThemeColors.darkColorFullFaded};
    }
    svg{
        color:${(props) =>
          props.selected
            ? lightThemeColors.primaryColor
            : lightThemeColors.darkColorFullFaded};
    }
`;
